<div class="main-wrapper">
  <!-- partial:sidebar -->
  <app-sidebar></app-sidebar>

  <div class="page-wrapper">

    <!-- partial:navbar -->
    <app-navbar></app-navbar>

    <div class="page-content">

      <!-- Spinner for lazyload modules -->
      <div *ngIf="isLoading" class="spinner-wrapper">
        <div class="spinner" translate>Loading...</div>
      </div>

      <!-- Content page -->
      <div contentAnimate *ngIf="!isLoading">
        <router-outlet></router-outlet>
      </div>

      <!-- partial:support -->
      <app-support *ngIf="accessLink()"></app-support>

    </div>

    <!-- partial:footer -->
    <app-footer></app-footer>

  </div>
</div>